import React, { useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Button,
  Tooltip,
} from "@mui/material";
import InputFields from "../FieldsUi/InputFields";
import { pageScrollStyle } from "../../../../styles/styles";
import Header from "./components/Header";
import { useDialog } from "../../../DialogContext";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { LoadingButton } from "@mui/lab";
import { useForm } from "react-hook-form";

const PreviewForm = ({ tabBtn, formData, handleSave, saveLoad }) => {
  const { closeDialog } = useDialog();
  const [activeSection, setActiveSection] = useState(0);

  console.log(formData);
  const formSections =
    tabBtn === 1
      ? formData?.createNewMatter?.sections
      : formData?.quickCreateNewMatter?.sections;

  const templateName = formData?.template_name || "";
  const practiceAreaId = formData?.practice_area?.toString() || "";

  const DotStepIcon = ({ active, completed }) => {
    return (
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: completed || active ? "primary.light" : "#c4c4c4",
        }}
      />
    );
  };

  const getFieldWidth = (sectionColumns) => {
    switch (sectionColumns) {
      case 1:
        return "100%";
      case 2:
        return "calc(50% - 0.5rem)";
      case 3:
      default:
        return "calc(33.33% - 0.67rem)";
    }
  };

  const handleSectionClick = (sectionIndex) => {
    setActiveSection(sectionIndex);

    const sectionId =
      formSections[sectionIndex]?.section_name?.replace(/\s+/g, "-") ||
      formSections[sectionIndex]?.name?.replace(/\s+/g, "-");

    const sectionElement = document.getElementById(`section-${sectionId}`);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Box>
      <Header
        tabBtn={tabBtn}
        templateName={templateName}
        practiceAreaId={practiceAreaId}
        isreadonly={true}
        placeType={"previewForm"}
      />
      {tabBtn === 1 ? (
        <Box
          sx={{
            height: "calc(100vh - 2.8rem)",
            margin: "0 auto",
            display: "flex",
            border: "1px solid #e0e0e0",
            borderRadius: "4px",
            bgcolor: "#ffffff",
            overflow: "hidden",
          }}
        >
          {/* Left Panel */}
          <Box
            sx={{
              width: "22%",
              minWidth: "12rem",
              borderRight: "1px solid #e0e0e0",
              backgroundColor: "#fafafa",
              display: "flex",
              flexDirection: "column",
              p: "1rem",
              gap: "0.5rem",
              overflowY: "auto",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              All Sections
            </Typography>
            <Divider sx={{ mb: 1 }} />
            <Stepper
              orientation="vertical"
              activeStep={activeSection}
              nonLinear={true}
              connector={
                <Box
                  sx={{
                    ml: 0.5,
                    height: "1.4rem",
                    borderLeft: "1px dotted #bdbdbd",
                  }}
                />
              }
            >
              {formSections.map((section, index) => (
                <Step key={index} completed={false}>
                  <StepLabel
                    StepIconComponent={DotStepIcon}
                    onClick={() => handleSectionClick(index)}
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: activeSection === index ? 600 : 400,
                        color:
                          activeSection === index ? "primary" : "text.primary",
                        textDecoration:
                          activeSection === index ? "underline" : "none",
                      }}
                    >
                      {section.name || section.section_name}
                    </Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>

          {/* Right Panel */}
          <Box
            sx={{
              width: "78%",
              height: "100%",
              position: "relative",
              backgroundColor: "#f7f9fc",
              overflowY: "auto",
              ...pageScrollStyle,
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                p: "1rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  margin: "0 auto",
                }}
              >
                {formSections.map((section, i) => (
                  <Box key={i}>
                    <Box
                      id={`section-${(
                        section.section_name || section.name
                      ).replace(/\s+/g, "-")}`}
                      sx={{
                        border: "1px solid #e0e0e0",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          backgroundColor: "#f5f5f5",
                          p: "0.5rem 1rem",
                          borderBottom: "1px solid #e0e0e0",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSectionClick(i)}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: "500",
                          }}
                        >
                          {section.name || section.section_name}
                        </Typography>
                        {section?.fields?.length === 0 && (
                          <Tooltip
                            arrow
                            size="small"
                            color="error"
                            title="This section not visible in actual form because it don't have any field."
                          >
                            <WarningRoundedIcon />
                          </Tooltip>
                        )}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "1rem",
                          alignItems: "flex-start",
                          p: "1rem",
                          backgroundColor: "#ffffff",
                        }}
                      >
                        {section.fields.map(
                          (field, j) =>
                            field.type !== "section" && (
                              <Box
                                key={j}
                                sx={{
                                  width: getFieldWidth(section.columns),
                                }}
                              >
                                <InputFields
                                  field={field}
                                  className="preview-input-field"
                                  isSmall={true}
                                />
                              </Box>
                            )
                        )}
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                backdropFilter: "blur(4px)",
                WebkitBackdropFilter: "blur(4px)",
                borderTop: "1px solid #FFFFFF2E",
                p: "0.5rem 1rem",
                gap: "1rem",
                backgroundColor: "#f7f9fc",
                zIndex: 10,
              }}
            >
              <Button
                variant="outlined"
                size="small"
                onClick={closeDialog}
                sx={{ fontSize: "0.8rem" }}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={saveLoad}
                variant="contained"
                size="small"
                onClick={handleSave}
                sx={{ fontSize: "0.8rem" }}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              flexGrow: 1,
              p: "1rem",
              backgroundColor: "#ffffff",
              ...pageScrollStyle,
            }}
          >
            {formSections.map((section, i) => (
              <Box key={i}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  {section.fields.map(
                    (field, j) =>
                      field.type !== "section" && (
                        <Box
                          key={j}
                          sx={{
                            width: getFieldWidth(section.columns),
                          }}
                        >
                          <InputFields
                            field={field}
                            className="preview-input-field"
                            isSmall={true}
                          />
                        </Box>
                      )
                  )}
                </Box>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
              borderTop: "1px solid #FFFFFF2E",
              p: "0.5rem 1rem",
              gap: "1rem",
              backgroundColor: "#f7f9fc",
              zIndex: 10,
            }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={closeDialog}
              sx={{ fontSize: "0.8rem" }}
            >
              Cancel
            </Button>
            <LoadingButton
              loading={saveLoad}
              variant="contained"
              size="small"
              onClick={handleSave}
              sx={{ fontSize: "0.8rem" }}
            >
              Save
            </LoadingButton>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PreviewForm;
